export default {
  title: 'Send a message',
  businessLine: 'Line of business',
  contract: 'Contract',
  object: 'Topic',
  subject: 'Subject',
  assignments: 'Recipient (optional)',
  specify: 'Specify',
  contractNumber: 'Contract Number (optional)',
  contractNumberErrorMessage: 'The format is not valid.',
  sendMessageButton: 'Send',
  cancelMessageButton: 'Cancel',
  messageSentSnackbar: 'Message sent',
  disabled: 'Disabled',
};
